import { LinearProgress } from '@mui/material';
import * as React from 'react';

interface ILoadingPageProps {}

export const LoadingPage: React.FunctionComponent<ILoadingPageProps> = () => {
    return <LinearProgress />;
};
